export default __webpack_public_path__ + "static/media/negative-circle-fill.218ce047.svg";